






















import { Component, Prop, Vue } from "vue-property-decorator";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { TDocumentDefinitions } from "pdfmake/interfaces";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface ColumnaExport {
  label: string;
  field: string;
  width?: number | string;
}

@Component
export default class ExportarPdfGenerico extends Vue {
  @Prop({ type: Array, required: true }) readonly items!: Array<Record<string, unknown>>;
  @Prop({ type: Array, required: true }) readonly columns!: ColumnaExport[];
  @Prop({ type: String, required: true }) readonly title!: string;
  @Prop({ type: String, default: "" }) readonly subtitle!: string;
  @Prop({ type: String, default: "" }) readonly fileName!: string;
  @Prop({ type: Boolean, default: true }) readonly landscape!: boolean;

  private getValue(item: Record<string, unknown>, path: string): string {
    const parts = path.split(".");
    let current: unknown = item;
    for (const p of parts) {
      if (current == null || typeof current !== "object") return "";
      current = (current as Record<string, unknown>)[p];
    }
    if (current == null) return "";
    return String(current);
  }

  exportPdf(): void {
    if (!this.items || this.items.length === 0) return;

    const headerRow = this.columns.map((c) => ({
      text: c.label,
      style: "tableHeader",
    }));

    const bodyRows = this.items.map((item, index) => {
      const fill = index % 2 === 0 ? "#f8f9fa" : "#ffffff";
      return this.columns.map((c) => ({
        text: this.getValue(item, c.field),
        style: "tableCell",
        fillColor: fill,
      }));
    });

    const fechaReporte = new Date().toLocaleDateString("es-CL", {
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

    const widths = this.columns.map((c) => c.width ?? "*");

    const docDefinition: TDocumentDefinitions = {
      content: [
        {
          columns: [
            {
              width: "*",
              stack: this.subtitle
                ? [
                    { text: this.title, style: "title" },
                    { text: this.subtitle, style: "subtitle" },
                  ]
                : [{ text: this.title, style: "title" }],
            },
            {
              width: "auto",
              text: fechaReporte,
              style: "fecha",
              alignment: "right",
            },
          ],
          margin: [0, 0, 0, 4],
        },
        {
          canvas: [
            {
              type: "line",
              x1: 0,
              y1: 0,
              x2: 515,
              y2: 0,
              lineWidth: 1,
              lineColor: "#1565c0",
            },
          ],
          margin: [0, 0, 0, 12],
        },
        {
          text: `Total de registros: ${this.items.length}`,
          style: "info",
          margin: [0, 0, 0, 8],
        },
        {
          table: {
            widths,
            body: [headerRow, ...bodyRows],
          },
          layout: {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
          },
          margin: [0, 0, 0, 20],
        },
        {
          text: "Documento generado electrónicamente.",
          style: "footer",
          alignment: "center",
          margin: [0, 8, 0, 0],
        },
      ],
      pageOrientation: (this.landscape ? "landscape" : "portrait") as "landscape" | "portrait",
      pageMargins: [40, 50, 40, 50],
      styles: {
        title: { fontSize: 18, bold: true, color: "#0d47a1" },
        subtitle: { fontSize: 14, bold: true, color: "#1565c0", margin: [0, 2, 0, 0] },
        fecha: { fontSize: 9, color: "#546e7a" },
        info: { fontSize: 9, color: "#37474f" },
        tableHeader: {
          bold: true,
          fontSize: 9,
          fillColor: "#1565c0",
          color: "white",
          margin: [4, 6, 4, 6],
          alignment: "center",
        },
        tableCell: {
          fontSize: 8,
          margin: [4, 5, 4, 5],
          alignment: "center",
        },
        footer: { fontSize: 7, color: "#78909c", italics: true },
      },
      defaultStyle: { fontSize: 8 },
    };

    const name = this.fileName && this.fileName.trim().length > 0 ? this.fileName : "reporte.pdf";
    pdfMake.createPdf(docDefinition).download(name);
  }
}
